import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import {
  Button,
  Grid,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  Link 

} from "@mui/material";
import {
  EditOutlined,
  DeleteOutline,
  Search,
  PersonAddAlt1,
  ChevronLeft,
  ChevronRight,
  Download,
Visibility
} from "@mui/icons-material";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import _ from "lodash";

//Services
import demoaccountapi from "Services/Demoaccount";

//Modals
import PassengerAddModal from "Pages/Modals/Demoaccount/Create";
import PassengerUpdateModal from "Pages/Modals/Demoaccount/Update";
import PassengerDeleteDialog from "Pages/Modals/Demoaccount/Delete";

const Demoaccount = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);
  const [currentRowData, setCurrentRowData] = useState({});
  const [customerId, setCustomerId] = useState("");

  //Pagination
  const [page, setPage] = useState(1); // API expects 1-indexed
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(1);
  const [searchText, setSearchText] = useState("");

  //Modals
  const [addPassenderModal, setAddPassengerModal] = useState(false);
  const handleOpenAddPassengerModal = () => setAddPassengerModal(true);
  const handleCloseAddPassengerModal = () => {
    setAddPassengerModal(false);
    getPassengers();
  };

  const [updatePassenderModal, setUpdatePassengerModal] = useState(false);
  const handleOpenUpdatePassengerModal = (row) => {
    setCurrentRowData(row);
    setCustomerId(row?.demoaccount_id);
    setUpdatePassengerModal(true);
  };
  const handleCloseUpdatePassengerModal = () => {
    setUpdatePassengerModal(false);
    getPassengers();
  };

  const [deletePassengerModal, setdeletePassengerModal] = useState(false);
  const handleOpenDeletePassengerModal = (row) => {
    setCustomerId(row?.demoaccount_id);
    setdeletePassengerModal(true);
  };
  const handleCloseDeleteServiceModal = () => {
    setdeletePassengerModal(false);
    getPassengers();
  };

  const handleToggleStatus = (rowData) => {
    const demoaccountId = rowData?.demoaccount_id;
    if (!demoaccountId) {
      dispatch(
        showSnackbar({
          message: "Demo Account ID not found",
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        })
      );
      return;
    }

    const newIsActive = rowData?.isActive === 1 ? 0 : 1;
    dispatch(showLoader("Updating status..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: "Status updated successfully",
            variant: "success",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
          })
        );
        getPassengers();
      } else {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Failed to update status",
            variant: "error",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
          })
        );
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error updating status",
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        })
      );
    };

    demoaccountapi.updateDemoAccount(demoaccountId, { isActive: newIsActive })
      .then(onSuccess, onFailure);
  };

  const getPassengers = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalRecords(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        })
      );
    };
    demoaccountapi
      .getPassengersList({ page, limit: pageSize, search: ""})
      .then(onSuccess, onFailure);
  }, [page, pageSize, dispatch]);

  const getallpassengers = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        setbulkrow(res?.data?.data?.data);
      } else {
        setbulkrow([]);
      }
    };
    const onFailure = (err) => {
      console.error("error fetch bulk", err);
    };
    demoaccountapi
      .getPassengersList({ page:1, limit: "unlimited", search: ""})
      .then(onSuccess, onFailure);
  }, []);

  useEffect(() => {
    getPassengers();
    getallpassengers();
  }, [getPassengers, getallpassengers]);

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  const filteredRow = (row || []).filter((data) => {
    if (!searchText) return true;
    const searchLower = searchText.toLowerCase();
    const fullName = `${data?.firstName || ""}`.toLowerCase();
    const mobile = `${data?.countryCode || ""} ${data?.mobileNumber || ""}`.toLowerCase();
    return (
      fullName.includes(searchLower) ||
      data?.email?.toLowerCase().includes(searchLower) ||
      mobile.includes(searchLower) ||
      data?.SellerEmail?.toLowerCase().includes(searchLower) ||
      (data?.isActive === 1 ? "active" : "inactive").includes(searchLower)
    );
  });

  const dataRows = _.map(filteredRow || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    firstName: data?.firstName,
    email: data?.email,
    mobile: data?.countryCode + " " + data?.mobileNumber,
    password: data?.showPassword,
    selleremailid: data?.SellerEmail,
    status: data?.isActive === 1 ? "Active" : "Inactive",
    row: data,
    pdfPath: data?.pdfurl,
otp: data?.otp 
  }));

  const bulkdataRows = _.map(
    _.orderBy(bulkrow || [], ['createdAt'], ['asc']),
    (data, index) => ({
      sno: index + 1,
      firstName: data?.firstName,
      email: data?.email,
      mobile: data?.countryCode + " " + data?.mobileNumber,
      row: data,
    })
  );

  const handleDownloadAll = () => {
    const bulkformatteddatas = bulkdataRows.map((row) => ({
      "S.NO": row.sno,
      "First Name": row.firstName,
      "Email": row.email,
      "Mobile": row.mobile,
    }));
    const csv = Papa.unparse(bulkformatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "All PassengerList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleCopy = () => {
    const columnWidths = [5, 15, 25, 15, 15];
    const padText = (text, width) => (text ?? "").toString().padEnd(width, " ");
    const header = [
      padText("S.NO", columnWidths[0]),
      padText("First name", columnWidths[1]),
      padText("Email", columnWidths[2]),
      padText("Mobile", columnWidths[3]),
      padText("Status", columnWidths[4]),
    ].join("");
  
    const rows = dataRows
      .map((row) =>
        [
          padText(row.sno, columnWidths[0]),
          padText(row.firstName, columnWidths[1]),
          padText(row.email, columnWidths[2]),
          padText(row.mobile, columnWidths[3]),
          padText(row.status, columnWidths[4]),
        ].join("")
      )
      .join("\n");
  
    const formattedContent = [header, rows].join("\n");
    navigator.clipboard.writeText(formattedContent).then(() => {
      dispatch(
        showSnackbar({
          message: "Copied table to clipboard!",
          variant: "success",
          autoHideDuration: 2000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        })
      );
    });
  };

  const handleDownloadExcel = () => {
    const formatteddatas = dataRows.map((row) => ({
      "S.NO": row.sno,
      "First Name": row.firstName,
      "Email": row.email,
      "Mobile": row.mobile,
      "Password": row.password,
      "Seller Email Id": row.selleremailid,
      "Status": row.status,
    }));
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "DemoAccount");
    XLSX.writeFile(workbook, "DemoAccountList.xlsx");
  };

  const handleDownloadCSV = () => {
    const formatteddatas = dataRows.map((row) => ({
      "S.NO": row.sno,
      "First Name": row.firstName,
      "Email": row.email,
      "Mobile": row.mobile,
      "Password": row.password,
      "Seller Email Id": row.selleremailid,
      "Status": row.status,
    }));
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "DemoAccountList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((row) => [
      row.sno,
      row.firstName,
      row.email,
      row.mobile,
      row.status
    ]);
    doc.autoTable({
      head: [["S.NO", "First Name", "Email", "Mobile", "Status"]],
      body: tableData,
    });
    doc.save("DemoAccountList.pdf");
  };

  const handleDownload = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "Unicodell-Demo-Account-Credentials.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
    setPage(1);
  };

  // Pagination Logic
  const totalPagesCount = Math.ceil(totalRecords / pageSize);

  const renderPagination = () => {
    let pages = [];
    const internalPage = page - 1; // 0-indexed for calculation

    if (totalPagesCount <= 5) {
      for (let i = 0; i < totalPagesCount; i++) {
        pages.push(i);
      }
    } else {
      if (internalPage < 3) {
        pages = [0, 1, 2, "...", totalPagesCount - 1];
      } else if (internalPage > totalPagesCount - 4) {
        pages = [
          0,
          "...",
          totalPagesCount - 3,
          totalPagesCount - 2,
          totalPagesCount - 1,
        ];
      } else {
        pages = [
          0,
          "...",
          internalPage - 1,
          internalPage,
          internalPage + 1,
          "...",
          totalPagesCount - 1,
        ];
      }
    }

    return pages.map((item, index) => {
      if (item === "...") {
        return (
          <span key={index} className={classes.pageDots}>
            ...
          </span>
        );
      }

      return (
        <Button
          key={item}
          className={
            internalPage === item
              ? classes.pageButtonActive
              : classes.pageButton
          }
          onClick={() => setPage(item + 1)}
        >
          {item + 1}
        </Button>
      );
    });
  };

  return (
    <Box className={classes.root}>
      {/* Header Container */}
      <Box className={classes.headerContainer}>
        <Typography className={classes.pageTitle}>Demo Account</Typography>
        <Typography className={classes.breadcrumb}>
          Admin / <span>Demo Account</span>
        </Typography>
      </Box>

      {/* Actions and Search Bar Row */}
      <Box className={classes.actionRow}>
        <Box className={classes.searchWrapper}>
          <Search className={classes.searchIcon} />
          <input
            type="text"
            placeholder="Search"
            value={searchText}
            onChange={handleSearchChange}
            className={classes.searchInput}
          />
        </Box>

        <Box style={{ display: "flex", gap: "16px", alignItems: "center" }}>
          {/* Download/Copy bar */}
          <Box className={classes.exportGroup}>
            <Button className={classes.exportButton} onClick={handleCopy}>
              Copy
            </Button>
            <Button className={classes.exportButton} onClick={handleDownloadExcel}>
              Excel
            </Button>
            <Button className={classes.exportButton} onClick={handleDownloadCSV}>
              CSV
            </Button>
            <Button className={classes.exportButton} onClick={handleDownloadPDF}>
              PDF
            </Button>
            <Button className={classes.exportButton} onClick={handleDownloadAll}>
              Download All
            </Button>
          </Box>

          <Button
            variant="contained"
            className={classes.addCustomerButton}
            onClick={handleOpenAddPassengerModal}
            startIcon={<PersonAddAlt1 />}
          >
            Add Demoaccount
          </Button>
        </Box>
      </Box>

      {/* Data Table */}
      <TableContainer component={Paper} elevation={0} className={classes.tableWrapper}>
        <Table>
          <TableHead>
            <TableRow className={classes.tableHeaderRow}>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 0.5 }}>
                S.No
              </TableCell>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 1.5 }}>
                Full Name
              </TableCell>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 2 }}>
                Email Address
              </TableCell>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 1.5 }}>
                Mobile
              </TableCell>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 1.5 }}>
                Seller Email Id
              </TableCell>
 <TableCell className={classes.tableHeaderCell} style={{ flex: 1 }}>
                OTP
              </TableCell>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 1 }}>
                Status
              </TableCell>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 2, textAlign: "right" }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataRows.map((rowItem) => (
              <TableRow key={rowItem.sno} className={classes.tableRow}>
                <TableCell className={classes.tableCell} style={{ flex: 0.5 }}>
                  {rowItem.sno}
                </TableCell>
                <TableCell
                  className={`${classes.tableCell} ${classes.boldText}`}
                  style={{ flex: 1.5 }}
                >
                  {rowItem.firstName}
                </TableCell>
                <TableCell className={classes.tableCell} style={{ flex: 2 }}>
                  {rowItem.email}
                </TableCell>
                <TableCell className={classes.tableCell} style={{ flex: 1.5 }}>
                  {rowItem.mobile}
                </TableCell>
                <TableCell className={classes.tableCell} style={{ flex: 1.5 }}>
                  {rowItem.selleremailid}
                </TableCell>
 <TableCell className={classes.tableCell} style={{ flex: 1 }}>
                  {rowItem.otp}
                </TableCell>
                <TableCell className={classes.tableCell} style={{ flex: 1 }}>
                  <span
                    onClick={() => handleToggleStatus(rowItem.row)}
                    style={{ cursor: "pointer" }}
                    className={
                      rowItem.status === "Active"
                        ? classes.statusBadgeActive
                        : classes.statusBadgeInactive
                    }
                  >
                    {rowItem.status}
                  </span>
                </TableCell>
                <TableCell className={classes.tableCell} style={{ flex: 2, textAlign: "right", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                  {rowItem.pdfPath && (
                    <Tooltip title="View PDF">
                      <Link href={rowItem.pdfPath} target="_blank" color="primary" size="small" style={{ marginRight: 8 }}>
                        <Visibility fontSize="small" />
                      </Link>
                    </Tooltip>
                  )}

 {rowItem.pdfPath && (
                    <Tooltip title="Download PDF">
                      <IconButton color="primary" onClick={() => handleDownload(rowItem.pdfPath)} size="small" style={{ marginRight: 8 }}>
                        <Download fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                  <Box
                    component="span"
                    className={classes.actionButton}
                    onClick={() => handleOpenUpdatePassengerModal(rowItem.row)}
                  >
                    <EditOutlined fontSize="small" /> Edit
                  </Box>
                  <Box
                    component="span"
                    className={classes.actionDeleteButton}
                    onClick={() => handleOpenDeletePassengerModal(rowItem.row)}
                  >
                    <DeleteOutline fontSize="small" /> Delete
                  </Box>
                </TableCell>
              </TableRow>
            ))}
            {dataRows.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} style={{ textAlign: "center", padding: "32px" }}>
                  <Typography variant="body2" color="textSecondary">
                    No records found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <Box className={classes.paginationContainer}>
          <Typography className={classes.paginationText}>
            Showing {(page - 1) * pageSize + 1} to{" "}
            {Math.min(page * pageSize, totalRecords)} of {totalRecords} results
          </Typography>

          <Box className={classes.paginationControls}>
            <ChevronLeft
              className={`${classes.pageArrow} ${page === 1 ? "disabled" : ""}`}
              onClick={() => page > 1 && setPage(page - 1)}
            />

            {renderPagination()}

            <ChevronRight
              className={`${classes.pageArrow} ${page === totalPagesCount ? "disabled" : ""}`}
              onClick={() => page < totalPagesCount && setPage(page + 1)}
            />
          </Box>
        </Box>
      </TableContainer>

      <PassengerAddModal
        openDialog={addPassenderModal}
        handleClose={handleCloseAddPassengerModal}
      />
      <PassengerUpdateModal
        openDialog={updatePassenderModal}
        id={customerId}
        handleClose={handleCloseUpdatePassengerModal}
      />
      <PassengerDeleteDialog
        openDialog={deletePassengerModal}
        id={customerId}
        handleClose={handleCloseDeleteServiceModal}
      />
    </Box>
  );
};

export default Demoaccount;
